module.exports = __webpack_public_path__ + "media/img/iryo/infinita-cd456145a58fb332ab827eec36001cef.png";